export default __webpack_public_path__ + "scripts/resource/cb81621af50ae81b55ee620350f93862.svg";